module.exports = __webpack_public_path__ + "f1256867abaa35b8b9827fb3d0533054.pdf";